<script lang="ts">
	import { Button, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import TemplatesModal from 'src/components/Templates/TemplatesModal.svelte';
	import type { Device } from 'src/types/Device';

	let showTemplatesModal = false;
	// Minimal device object for manage mode - only needs basic properties
	const minimalDevice: Device = {
		id: 'manage-templates',
		gen: '2',
		type: 'template-manager',
		name: 'Template Manager',
		room_id: 0,
		position: 0,
		image: '',
		channel: 0,
	};
</script>

<Button variant="primary" size="m" on:click={() => (showTemplatesModal = true)}>
	{$format('button_manage_templates', {
		default: 'Manage Templates',
	})}
</Button>

{#if showTemplatesModal}
	<TemplatesModal bind:showModal={showTemplatesModal} device={minimalDevice} mode="manage" />
{/if}
